import React from "react";
import { connect } from "react-redux";
import language from "../../../language";
import { Table } from "../../Table";
import { Modal, DeleteModal } from "../../Modal";
import { CSVLink } from "react-csv";
import { getStorage } from "../../../utils/storage";
import icons from "../../../constants/icons";
import moment from "moment";
import {
  fetchQualysResult,
  deleteQualysResult,
} from "../../../utils/queries/qualysResult";

class QualysTest extends React.Component {
  csvDownload = React.createRef();

  state = {
    isLoading: false,
    data: [],
    page: 1,
    limit: 10,
    search_text: "",
    selectedData: {},
    totalPageCount: 10,
    delete_password: "",
    delete_value: "",
    error: {},
    csvData: [],
    user: {},
    filters: {
      // startDate: moment().subtract(1, "month").format("YYYY-MM-DD"),
      // endDate: moment().format("YYYY-MM-DD"),
    },
  };

  componentDidMount = async () => {
    const user = await getStorage();
    this.setState({ user });

    await this.fetchData(true, this.state.filters);
  };

  buildNextFilters = (params = {}) => {
    const nextFilters = {
      ...this.state.filters,
      ...params,
    };

    const hasSampleIdParam = Object.prototype.hasOwnProperty.call(
      params,
      "sampleId",
    );

    if (hasSampleIdParam && !params.sampleId) {
      delete nextFilters.sampleId;
    }

    return nextFilters;
  };

  fetchData = async (isLoading, params = {}) => {
    const nextFilters = this.buildNextFilters(params);

    this.setState(
      {
        filters: nextFilters,
        page: 1,
      },
      () => this.getData(isLoading, nextFilters),
    );
  };

  onChangeText(field, e) {
    let { error } = this.state;

    delete error[field];

    this.setState({ error, [field]: e?.target?.value });
  }

  getData = async (isLoading, search = {}) => {
    try {
      const { page, limit } = this.state;
      const { defaultLanguage } = this.props;
      const filters = this.buildNextFilters(search);

      this.setState({
        isLoading,
        filters,
      });

      const { data, count, totalRecords } = await fetchQualysResult(defaultLanguage, {
        page,
        limit,
        ...filters,
      });

      this.setState({
        data,
        totalPageCount: count,
        totalRecords,
        isLoading: false,
      });
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handlePagination(page, _tab, limit) {
    this.setState(
      {
        page,
        ...(limit != null && { limit }),
      },
      () => {
        this.getData(true);
      },
    );
  }

  handleLimitChange(limit) {
    this.setState({ limit, page: 1 }, () => {
      this.getData(true);
    });
  }

  handleShowModal(modal, modalTitle, selectedData = {}) {
    this.setState({
      [modal]: true,
      modalTitle: modalTitle,
      selectedData,
    });
  }

  handleCloseModal(modal) {
    this.setState({
      [modal]: false,
    });
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].sample_id,
        key: "sampleId",
        type: "link",
        onPress: (item) =>
          this.handleShowModal("showModal", item.sampleId, item),
        styles: {
          textTransform: "uppercase",
        },
      },
      {
        title: language[this.props.defaultLanguage].instrument_run_id,
        key: "instrumentRunId",
      },
      {
        title: language[this.props.defaultLanguage].abo_group,
        key: "aboGroup",
      },

      {
        title: language[this.props.defaultLanguage].rh,
        key: "rh",
      },
      {
        title: language[this.props.defaultLanguage].kell,
        key: "kell",
      },
      {
        title: language[this.props.defaultLanguage].phenotype,
        key: "phenotype",
      },
      {
        title: language[this.props.defaultLanguage].blood_group,
        key: "bloodGroup",
      },
      {
        title: language[this.props.defaultLanguage].created_at,
        key: "observedAt",
        isMoment: true,
        inputFormat: "YYYYMMDDHHmmss",
        formatTime: "lll",
      },
      {
        title: language[this.props.defaultLanguage].operator,
        key: "operator",
      },
    ].filter(Boolean);

    return headers;
  }

  onDelete = async () => {
    try {
      this.setState({ isDeleting: true });

      await deleteQualysResult(
        this.props.defaultLanguage,
        this.state.selectedData._id,
      );

      this.setState({ isDeleting: false });

      this.getData(true);
      this.handleCloseModal("showDeleteModal");
    } catch (error) {
      console.log(error);
      this.setState({
        isDeleting: false,
      });
    }
  };

  handleRemoteSearch = async (search) => {
    await new Promise((r) => this.setState({ searching: true, page: 1 }, r));

    await this.fetchData(true, {
      sampleId: search && search.trim() ? search.trim() : undefined,
    });

    this.setState({
      searching: false,
    });
  };

  handleSearch = async (e) => {
    const search = e?.target?.value;
    this.setState({ search_text: search });
  };

  renderItem = (label, value, type, inputFormat) => {
    return (
      <div
        style={{
          display: "flex",
          minHeight: "35px",
          alignItems: "center",
          borderBottom: "1px solid #ddd",
        }}
      >
        <div style={{ flex: 1 }}>
          <p>{label}:</p>
        </div>
        <div>
          <p>
            <b>
              {value && type === "date"
                ? inputFormat
                  ? moment(value, inputFormat).format("DD/MM/YYYY HH:mm")
                  : moment(value).format("DD/MM/YYYY HH:mm")
                : value}
            </b>
          </p>
        </div>
      </div>
    );
  };

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          fetchData={(isLoading, search) => this.fetchData(isLoading, search)}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          addSearchButton
          searching={this.state.searching}
          handleSearch={this.handleSearch.bind(this)}
          handlePressSearch={() =>
            this.handleRemoteSearch(this.state.search_text)
          }
          totalPageCount={this.state.totalPageCount}
          totalRecords={this.state.totalRecords}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          onLimitChange={this.handleLimitChange.bind(this)}
          headers={this.returnTableHeaders()}
          rowPress={(item) =>
            this.handleShowModal("showModal", item.sampleId, item)
          }
          filters={[
            // {
            //   type: "dropdown",
            //   filterName: "date_range",
            //   title: language[this.props.defaultLanguage].date_range,
            //   button_type: "dropdown",
            //   startDate: this.state.filters.startDate,
            //   endDate: this.state.filters.endDate,
            // },
            {
              type: "button",
              title: language[this.props.defaultLanguage].refresh,
              button_type: "button",
              icon: icons.refresh,
              onPress: () => this.fetchData(true, this.state.filters),
            },
          ]}
        />

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showModal")}
          show={this.state.showModal}
          title={this.state.modalTitle}
          showHeaderBottomBorder={false}
        >
          {this.state.selectedData && (
            <div className="card-body">
              {this.renderItem(
                language[this.props.defaultLanguage].sample_id,
                this.state.selectedData.sampleId,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].instrument_run_id,
                this.state.selectedData.instrumentRunId,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].abo_group,
                this.state.selectedData.aboGroup,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].rh,
                this.state.selectedData.rh,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].kell,
                this.state.selectedData.kell,
              )}

              {this.renderItem(
                language[this.props.defaultLanguage].phenotype,
                this.state.selectedData.phenotype,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].antibody_screening_coombs,
                this.state.selectedData.antibodyScreeningCoombs,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].antibody_screening_enzyme,
                this.state.selectedData.antibodyScreeningEnzyme,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].direct_coombs,
                this.state.selectedData.directCoombs,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].extended_phenotyping,
                this.state.selectedData.extendedPhenotyping,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].identification,
                this.state.selectedData.identification,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].hemolysines,
                this.state.selectedData.hemolysines,
              )}

              {this.renderItem(
                language[this.props.defaultLanguage].xmatch,
                this.state.selectedData.xmatch,
              )}
              {this.renderItem(
                language[this.props.defaultLanguage].created_at,
                this.state.selectedData.observedAt,
                "date",
                "YYYYMMDDHHmmss",
              )}

              {this.renderItem(
                language[this.props.defaultLanguage].operator,
                this.state.selectedData.operator,
              )}
            </div>
          )}
        </Modal>

        <Modal
          handleClose={this.handleCloseModal.bind(this, "showDeleteModal")}
          show={this.state.showDeleteModal}
          title={this.state.modalTitle}
        >
          <DeleteModal
            handleCloseModal={this.handleCloseModal.bind(
              this,
              "showDeleteModal",
            )}
            error={this.state.error.delete_password}
            value={this.state.delete_value}
            onDelete={this.onDelete.bind(this)}
            onChange={(e) => this.onChangeText("delete_value", e)}
            isDeleting={this.state.isDeleting}
            name={this.state.selectedData.name}
            getData={this.getData.bind(this)}
          />
        </Modal>
        <CSVLink
          ref={this.csvDownload}
          filename={"BloodGrouping-Mismatch" + new Date().getTime()}
          data={this.state.csvData}
        ></CSVLink>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(QualysTest);
